/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Courselocation1Inputs */

const en__field_courselocation1 = /** @type {(inputs: _Field_Courselocation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`course Location`)
};

const de__field_courselocation1 = /** @type {(inputs: _Field_Courselocation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurs Ort`)
};

/**
* | output |
* | --- |
* | "course Location" |
*
* @param {_Field_Courselocation1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_courselocation1 = /** @type {((inputs?: _Field_Courselocation1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Courselocation1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_courselocation1(inputs)
	return de__field_courselocation1(inputs)
});
export { _field_courselocation1 as "_field_courseLocation" }